module.exports = __webpack_public_path__ + "img/circle_num_2_red.37fed311.svg";